"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsPopoverList = void 0;
const react_1 = __importStar(require("react"));
const className_1 = require("../../utils/className");
exports.SmlsPopoverList = ({ data }) => {
    const [selectedTooltip, setSelectedTooltip] = react_1.useState();
    const icons = {
        plane: react_1.default.createElement(react_1.default.Fragment, null, "\uE539"),
        bed: react_1.default.createElement(react_1.default.Fragment, null, "\uE53A"),
        car: react_1.default.createElement(react_1.default.Fragment, null, "\uE531"),
        security: react_1.default.createElement(react_1.default.Fragment, null, "\uE32A"),
        ticket: react_1.default.createElement(react_1.default.Fragment, null, "\uE553"),
    };
    return (react_1.default.createElement("div", { className: "smls-popover-list" },
        react_1.default.createElement("ul", null,
            data.map((item) => (react_1.default.createElement("li", { id: item.id, key: item.id, "data-testid": item.id, onMouseEnter: (event) => {
                    setSelectedTooltip(data.find((tooltip) => tooltip.id === event.currentTarget.id));
                } }, item.customIcon ? (item.customIcon) : (react_1.default.createElement("i", { className: className_1.mapToCssModules([
                    'material-icons',
                    'notranslate',
                    item.color,
                ]) }, icons[item.materialIcon]))))),
            react_1.default.createElement("div", { className: "smls-popover" }, selectedTooltip === null || selectedTooltip === void 0 ? void 0 : selectedTooltip.tooltipMessage))));
};
//# sourceMappingURL=index.js.map